<script setup>
import { ref } from 'vue';
import Section from '@/components/Section.vue';
import PollutantModal from '@/components/sections/Pollutants/PollutantModal.vue';
import MoleculeTable from '@/components/Molecule/MoleculeTable.vue';
import {moleculeRows} from '@/data/molecule-rows';

const atOpenModal = (pollutant) => {
    currentPollutant.value = pollutant;
};

const atClose = () => {
    currentPollutant.value = null;
};

const currentPollutant = ref(null);
</script>

<template>
    <Section id="air pollutants">
        <h1>
            Air Pollutants
        </h1>
        <h2>
            <span>
                What are the main air pollutants?
            </span>
        </h2>

        <div class="Pollutants">
            <MoleculeTable @select="atOpenModal" :molecules="moleculeRows" :current="currentPollutant" />

            <PollutantModal v-if="currentPollutant" :pollutant="currentPollutant" @close="atClose" />
        </div>
    </Section>
</template>


<style lang="scss" scoped>
.Pollutants {
    position: relative;
}
</style>
